import React, { memo } from 'react'
import { useRoutes } from 'react-router-dom'

import routes from './router'
import AppHeader from '@/components/AppHeader'
import AppFooter from './components/AppFooter'
import useScrollTop from './hooks/useScrollTop'

const App = memo(() => {
  // 切换路由时滚动到顶部
  useScrollTop()

  return (
    <div>
      <AppHeader />
      {useRoutes(routes)}
      <AppFooter />
    </div>
  )
})

export default App
